import { DEFAULT_US_CUSTOMER_TIMEZONE, getUsTimeZoneForState } from "./stateToTimezone.mjs";

// src/utils/bridgeDateOfService.ts
/**
* Bridge dateOfService for a visit instant in the visit state's local calendar
* day/time (avoids UTC day shift for late US slots).
*/
function formatBridgeDateOfServiceForUsState(instant, state) {
	return formatIsoDateTimeInTimeZone(instant, getUsTimeZoneForState(state) ?? "America/New_York");
}
function formatIsoDateTimeInTimeZone(instant, timeZone) {
	const parts = new Intl.DateTimeFormat("en-US", {
		timeZone,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hourCycle: "h23",
		fractionalSecondDigits: 3
	}).formatToParts(instant);
	const get = (type) => parts.find((part) => part.type === type)?.value ?? "00";
	const fractional = parts.find((part) => part.type === "fractionalSecond")?.value ?? "000";
	const offset = getTimeZoneOffsetString(instant, timeZone);
	return `${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get("minute")}:${get("second")}.${fractional}${offset}`;
}
function getTimeZoneOffsetString(date, timeZone) {
	const offsetPart = new Intl.DateTimeFormat("en-US", {
		timeZone,
		timeZoneName: "longOffset"
	}).formatToParts(date).find((part) => part.type === "timeZoneName")?.value;
	if (!offsetPart) return "Z";
	const match = offsetPart.match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
	if (!match) return "Z";
	return `${match[1]}${match[2].padStart(2, "0")}:${match[3] ?? "00"}`;
}

export { formatBridgeDateOfServiceForUsState };
//# sourceMappingURL=bridgeDateOfService.mjs.map